import { mediaRef } from '@/services/mediaAssets';
import planeViewImage from '@/assets/adventures/aws-reinvent-2024-zion-plane-view.jpg';

const bottleImage = mediaRef('adventures/aws-reinvent-zion-reckon-bottle.png');
const canyonViewImage = mediaRef('adventures/aws-reinvent-zion-canyon-view.png');
const crewHikeImage = mediaRef('adventures/aws-reinvent-zion-crew-hike.png');
const nightSkyImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2864.jpg');
const sunriseCliffsImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2867.jpg');
const dawnSilhouetteImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2868.jpg');
const geologyBriefingImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2871.jpg');
const trailDescentImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2875.jpg');
const trailSelfieImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2891.jpg');
const rockPassageImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2893.jpg');
const canyonRiverImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2896.jpg');
const canyonCreekImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2898.jpg');
const overlookCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2937.jpg');
const trailheadCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-171229.jpg');
const trailheadRoadImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-171416.jpg');
const sunsetWalkImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-171727.jpg');
const canyonOverlookImage = mediaRef('adventures/aws-reinvent-2024-zion-20241202-071457.jpg');
const overlookPortraitImage = mediaRef('adventures/aws-reinvent-2024-zion-20241202-082715.jpg');
const canyonCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-20241207-080654.jpg');
const creekPortraitImage = mediaRef('adventures/aws-reinvent-2024-zion-img-0227.jpg');
const mesaCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2925.jpg');
const trailheadSelfieImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2977.jpg');
const cliffsideCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-085327.jpg');
const trailBriefingImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-091502.jpg');
const canyonDescentImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-092057.jpg');
const slotCanyonImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-093042.jpg');
const slotCanyonCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-093209.jpg');
const cliffRailImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-100603.jpg');
const summitCelebrationImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-102910-0.jpg');
const sunlitTrailImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-105537.jpg');
const riverCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-133710.jpg');
const riversideCliffImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-134210.jpg');
const riversideRestImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-134527.jpg');
const canyonFloorCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-134803-0.jpg');
const finalDescentImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-161125.jpg');

const photo = (id, src, alt, caption = alt) => ({
  id: `zion-${id}`,
  src,
  alt,
  caption,
  position: 'center center',
});

export const zionPlaneViewPhoto = photo(
  'plane-view',
  planeViewImage,
  'Aerial view of Zion National Park sandstone cliffs from a plane approaching Las Vegas',
  'Our first glimpse of Zion from the plane window on the flight into Las Vegas.',
);

export const zionNightSkyPhoto = photo(
  'night-sky',
  nightSkyImage,
  'Stars above Zion before the 2024 hike began',
  'Looking up at one of the clearest night skies we had seen in years behind the hotel in Springdale.',
);

export const zionSunriseCliffsPhoto = photo(
  'sunrise-cliffs',
  sunriseCliffsImage,
  'Zion cliffs catching the first light of morning',
  'Our first view of Zion in daylight from the hotel parking lot in Springdale.',
);

export const zionScoutsLookoutStartPhoto = photo(
  'scouts-lookout-start',
  cliffsideCrewImage,
  'The Reckon crew at the beginning of the hike to Scout Lookout beneath a towering Zion cliff',
  'The crew together at the beginning of the hike to Scout Lookout.',
);

export const zionGeologyBriefingPhoto = photo(
  'geology-briefing',
  geologyBriefingImage,
  'Samantha explaining Zion geology to the Reckon crew during the hike to Scout Lookout',
  'Samantha explaining the geology surrounding us on the hike to Scout Lookout.',
);

export const zionSwitchbackGroupPhoto = photo(
  'switchback-group',
  canyonCrewImage,
  'The Reckon crew gathered at the end of a switchback above Zion Canyon',
  'A group photo at the end of one of the switchbacks on the climb to Scout Lookout.',
);

const zionHikeGallery = [
  zionPlaneViewPhoto,
  zionNightSkyPhoto,
  zionSunriseCliffsPhoto,
  zionScoutsLookoutStartPhoto,
  zionGeologyBriefingPhoto,
  zionSwitchbackGroupPhoto,
  photo(
    'crew-hike',
    crewHikeImage,
    'The Reckon crew resting together on the trail in Zion National Park',
    'A well-earned break on the trail in Zion National Park.',
  ),
  photo(
    'canyon-view',
    canyonViewImage,
    'A sweeping view across Zion Canyon beneath a blue sky',
    'The view across Zion Canyon during the 2024 adventure.',
  ),
  photo(
    'reckon-bottle',
    bottleImage,
    'A red Reckon water bottle overlooking Zion Canyon',
    'Reckon overlooking Zion Canyon.',
  ),
  photo('dawn-silhouette', dawnSilhouetteImage, 'Zion ridges silhouetted against the dawn sky'),
  photo('trail-descent', trailDescentImage, 'The Reckon crew descending a Zion trail with the canyon ahead'),
  photo('trail-selfie', trailSelfieImage, 'Two hikers smiling for a selfie between Zion canyon walls'),
  photo('rock-passage', rockPassageImage, 'Hikers making their way through a narrow Zion rock passage'),
  photo('canyon-river', canyonRiverImage, 'A high view over Zion Canyon and the river below'),
  photo('canyon-creek', canyonCreekImage, 'A quiet creek winding through the walls of Zion Canyon'),
  photo('overlook-crew', overlookCrewImage, 'The Reckon crew gathered at a Zion overlook'),
  photo('trailhead-crew', trailheadCrewImage, 'The full Reckon crew ready to begin the Zion hike'),
  photo('trailhead-road', trailheadRoadImage, 'The trailhead road leading toward Zion cliffs'),
  photo('sunset-walk', sunsetWalkImage, 'The crew walking beneath a colorful Zion sunset'),
  photo('canyon-overlook', canyonOverlookImage, 'A sunlit overlook across Zion Canyon and the winding road below'),
  photo('overlook-portrait', overlookPortraitImage, 'Two Reckon hikers together at a Zion overlook'),
  photo('creek-portrait', creekPortraitImage, 'Two hikers posing beside the creek in Zion'),
  photo('mesa-crew', mesaCrewImage, 'The Reckon crew at a wide Zion mesa overlook'),
  photo('trailhead-selfie', trailheadSelfieImage, 'A crew selfie at the start of the Zion hike'),
  photo('trail-briefing', trailBriefingImage, 'The hikers pausing for a trail briefing beside the canyon wall'),
  photo('canyon-descent', canyonDescentImage, 'The crew descending through a narrow opening toward the canyon view'),
  photo('slot-canyon', slotCanyonImage, 'A hiker exploring a narrow Zion slot canyon'),
  photo('slot-canyon-crew', slotCanyonCrewImage, 'The crew smiling together inside a Zion slot canyon'),
  photo('cliff-rail', cliffRailImage, 'The crew pausing at a cliffside rail on the Zion trail'),
  photo('summit-celebration', summitCelebrationImage, 'The Reckon crew celebrating together high above Zion Canyon'),
  photo('sunlit-trail', sunlitTrailImage, 'A hiker walking a sunlit path between Zion canyon walls'),
  photo('river-crew', riverCrewImage, 'The Reckon crew standing together in the river at Zion'),
  photo('riverside-cliff', riversideCliffImage, 'Two hikers on a boulder beneath a towering riverside cliff'),
  photo('riverside-rest', riversideRestImage, 'Two hikers resting on a boulder beneath the canyon walls'),
  photo('canyon-floor-crew', canyonFloorCrewImage, 'The full crew celebrating together on the Zion canyon floor'),
  photo('final-descent', finalDescentImage, 'The crew descending the trail beneath Zion sandstone cliffs'),
];

export default zionHikeGallery;
